import { formatPlatformName, PLATFORMS } from "../../constants/constants";
import {
  fetchOutlookProfile,
  fetchSlackProfile,
  fetchTrelloProfile,
} from "../../features/oauth/oauthAPI";
import { handleComposioAuth } from "../OAuth/ComposioAuth";
import { handleCustomPlatformAuth } from "../OAuth/CustomPlatform";
import {
  handleMicrosoftAuth,
  handleSlackAuth,
  handleTrelloAuth,
} from "../OAuth/PlatformAuth";

export const serverUrl = process.env.REACT_APP_SERVER;

export const openAuthLink = (url) => {
  window.location.href = url;
};

export const handlePlatformAuth = async ({
  assistant,
  settingData,
  dispatch,
  updateSetting,
  user,
  isOnboarding,
}) => {
  const platformType = assistant.platform?.type?.toLowerCase() || "";
  console.log(
    "These are the assistant details from handlePlatform auth: ",
    assistant,
  );

  let composioAuth = assistant.platform.composioAuth;

  const commonParams = {
    assistantId: assistant.uuid,
    setting: settingData,
    dispatch,
    updateSetting,
    platformType,
    user,
    isConfigRequired: assistant.platform.isConfigRequired,
    isOnboarding,
  };

  const composioCommonParams = {
    assistantId: assistant.uuid,
    openAuthLink,
    dispatch,
    seoName: assistant.seoName,
    platformType,
    user,
    isConfigRequired: assistant.platform.isConfigRequired,
    assistant,
  };
  if (platformType.includes(PLATFORMS.SLACK)) {
    return handleSlackAuth(commonParams);
  } else if (platformType.includes(PLATFORMS.TRELLO)) {
    return handleTrelloAuth(commonParams);
  } else if (
    platformType.includes(PLATFORMS.OUTLOOK) ||
    platformType.includes(PLATFORMS.OUTLOOK_CALENDAR) ||
    platformType.includes(PLATFORMS.MICROSOFT_TODO)
  ) {
    return handleMicrosoftAuth(commonParams);
  } else if (composioAuth === true) {
    console.log("we are inside composio: ", composioAuth);
    console.log(
      "These are the common Params from handlePlatfrom auth : ",
      commonParams,
    );
    return handleComposioAuth(composioCommonParams);
  } else {
    console.log("we are inside custom platform :", composioAuth);
    return handleCustomPlatformAuth(commonParams);
  }
};

export const getConnectionStatus = (
  isInstallPage,
  platformName,
  handleDisconnect,
) => {
  const platform = platformName?.toLowerCase() || "";

  const supportedPlatforms = [
    PLATFORMS.SLACK,
    PLATFORMS.ASANA,
    PLATFORMS.TRELLO,
    PLATFORMS.TODOIST,
    PLATFORMS.GMAIL,
    PLATFORMS.OUTLOOK,
    PLATFORMS.GOOGLE_CALENDAR,
    PLATFORMS.OUTLOOK_CALENDAR,
    PLATFORMS.MICROSOFT_TODO,
    PLATFORMS.OTHER,
    PLATFORMS.NONE,
    PLATFORMS.YOUTUBE,

    PLATFORMS.GITHUB,
    PLATFORMS.NOTION,
    PLATFORMS.GOOGLE_SHEETS,
    PLATFORMS.SUPABASE,
    PLATFORMS.PERPLEXITY_AI,
    PLATFORMS.TWITTER,
    PLATFORMS.GOOGLE_DRIVE,
    PLATFORMS.GOOGLE_DOCS,
    PLATFORMS.HUBSPOT,
    PLATFORMS.LINEAR,
    PLATFORMS.AIRTABLE,
    PLATFORMS.JIRA,
    PLATFORMS.FIRECRAWL,
    PLATFORMS.BITBUCKET,
    PLATFORMS.GOOGLE_TASKS,
    PLATFORMS.DISCORD,
    PLATFORMS.REDDIT,
    PLATFORMS.CAL,
    PLATFORMS.SENTRY,
    PLATFORMS.SNOWFLAKE,
    PLATFORMS.HACKER_NEWS,
    PLATFORMS.MICROSOFT_TEAMS,
    PLATFORMS.SHOPIFY,
    PLATFORMS.LINKEDIN,
    PLATFORMS.ONEDRIVE,
    PLATFORMS.DOCUSIGN,
    PLATFORMS.SALESFORCE,
    PLATFORMS.CALENDLY,
    PLATFORMS.APOLLO,
    PLATFORMS.SEMRUSH,
    PLATFORMS.NEON,
    PLATFORMS.OPENWEATHERMAP,
    PLATFORMS.POSTHOG,
    PLATFORMS.CLICKUP,
    PLATFORMS.BREVO,
    PLATFORMS.STRIPE,
    PLATFORMS.KLAVIYO,
    PLATFORMS.MAILCHIMP,
    PLATFORMS.GOOGLE_MEET,
    PLATFORMS.TEXT_TO_PDF,
    PLATFORMS.ZOHO,
    PLATFORMS.FIREFLIES,
    PLATFORMS.DROPBOX,
    PLATFORMS.CONFLUENCE,
    PLATFORMS.FRESHDESK,
    PLATFORMS.MIXPANEL,
    PLATFORMS.CODA,
    PLATFORMS.AFFINITY,
    PLATFORMS.AMPLITUDE,
    PLATFORMS.GOOGLE_BIGQUERY,
    PLATFORMS.MONDAY,
    PLATFORMS.PIPEDRIVE,
    PLATFORMS.BAMBOOHR,
    PLATFORMS.WHATSAPP,
    PLATFORMS.DYNAMICS_365,
    PLATFORMS.ZENDESK,
    PLATFORMS.GOOGLE_PHOTOS,
    PLATFORMS.META_ADS,
    PLATFORMS.LISTEN_NOTES,
    PLATFORMS.ZOOM,
    PLATFORMS.SERVICENOW,
    PLATFORMS.GOOGLE_ADS,
    PLATFORMS.MIRO,
    PLATFORMS.CONTENTFUL,
    PLATFORMS.NETSUITE,
    PLATFORMS.SURVEYMONKEY,
    PLATFORMS.ZOHO_BOOKS,
    PLATFORMS.ZOHO_INVENTORY,
    PLATFORMS.FACEBOOK,
    PLATFORMS.CANVA,
    PLATFORMS.BOX,
    PLATFORMS.FRESHBOOKS,
    PLATFORMS.PANDADOC,
    PLATFORMS.ZOHO_DESK,
    PLATFORMS.BASEROW,
    PLATFORMS.TINYURL,
    PLATFORMS.GUMROAD,
    PLATFORMS.FOURSQUARE,
    PLATFORMS.OPENSEA,
    PLATFORMS.CLOUDFLARE,
    PLATFORMS.XERO,
    PLATFORMS.ZOHO_MAIL,
    PLATFORMS.INTERCOM,
    PLATFORMS.EVENTBRITE,
    PLATFORMS.WORKDAY,
    PLATFORMS.ZOHO_INVOICE,
    PLATFORMS.STACK_EXCHANGE,
    PLATFORMS.DATADOG,
    PLATFORMS.BASECAMP,
    PLATFORMS.ALGOLIA,
    PLATFORMS.APIFY,
    PLATFORMS.GITLAB,
    PLATFORMS.JOTFORM,
    PLATFORMS.MAKE,
    PLATFORMS.PIPELINE_CRM,
    PLATFORMS.NOTION_MCP,
    PLATFORMS.NOCODB,
    PLATFORMS.OPENAI,
    PLATFORMS.PAPERFORM,
    PLATFORMS.QUICKBOOKS,
    PLATFORMS.SCRAPINGBEE,
    PLATFORMS.TICKTICK,
    PLATFORMS.TIKTOK,
    PLATFORMS.TOGGL,
    PLATFORMS.TYPEFORM,
    PLATFORMS.SALESFORCE_SERVICE_CLOUD,
  ];

  if (!supportedPlatforms.includes(platform)) {
    return {
      showButton: false,
      isSetup: false,
      buttonText: "",
      onClick: null,
    };
  }

  const getButtonText = () => {
    if (platform === PLATFORMS.OTHER || platform === PLATFORMS.NONE) {
      return !isInstallPage ? "Disconnect" : "Connect";
    }

    const formattedPlatform = formatPlatformName(platformName);

    return !isInstallPage
      ? `Disconnect ${formattedPlatform}`
      : `Connect ${formattedPlatform}`;
  };

  return {
    showButton: true,
    isSetup: false,
    buttonText: getButtonText(),
    onClick: !isInstallPage ? handleDisconnect : null,
  };
};

export const getPlatformCapabilities = (tools = []) => {
  if (!Array.isArray(tools)) return [];

  return tools.map((tool) => ({
    name: tool.name,
    available: Boolean(tool.isEnabled),
  }));
};

export const getPlatformDescription = (platform) => {
  const name = platform?.toLowerCase() || "";

  switch (name) {
    case PLATFORMS.ASANA:
      return "Create, update, delete, and manage tasks using this agent with authentication.";

    case PLATFORMS.SLACK:
      return "Reply to DMs, access groups, manage channels, perform CRUD operations, and handle reactions.";

    case PLATFORMS.TRELLO:
      return "Manage boards, create cards, update lists, assign members, and track project progress.";

    case PLATFORMS.TODOIST:
      return "Manage projects, create tasks, update priorities, set due dates, and track productivity.";

    case PLATFORMS.GMAIL:
      return "Read, send, reply, search, label, archive, and manage emails efficiently.";

    case PLATFORMS.OUTLOOK:
      return "Send, receive, organize, and manage emails with folders, flags, and attachments.";

    case PLATFORMS.GOOGLE_CALENDAR:
      return "Create, update, schedule, and manage events, reminders, and meetings seamlessly.";

    case PLATFORMS.OUTLOOK_CALENDAR:
      return "Create, update, schedule, and manage events, reminders, and meetings seamlessly.";

    case PLATFORMS.MICROSOFT_TODO:
      return "Create, update, delete, and manage tasks using this agent with authentication.";

    default:
      return "Connect and manage your workspace with automation and integration capabilities.";
  }
};

export const formatPhoneNumberUS = (digits) => {
  if (!digits) return "";

  const cleaned = String(digits).replace(/\D/g, "");

  if (cleaned.length !== 10) return cleaned;

  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};

export const extractUSLocalNumber = (num) => {
  if (!num) return "";
  const cleaned = String(num).replace(/\D/g, "");
  return cleaned.slice(-10);
};

export const getPlatformConfig = (platform) => {
  switch (platform) {
    case PLATFORMS.TRELLO:
      return {
        itemLabel: "Select Board",
        title: "Select Trello Workspace & Board",
        workspaceLabel: "Select Workspace",
        connectMessage:
          "Trello is not connected for this setting. Please connect Trello and try again.",
        showWorkspace: true,
      };
    case PLATFORMS.ASANA:
      return {
        itemLabel: "Select Project",
        title: "Select Asana Workspace & Project",
        workspaceLabel: "Select Workspace",
        connectMessage:
          "Asana is not connected for this setting. Please connect Asana and try again.",
        showWorkspace: true,
      };
    case PLATFORMS.TODOIST:
      return {
        itemLabel: "Select Project",
        title: "Select Todoist Project",
        workspaceLabel: "Select Workspace",
        connectMessage:
          "Todoist is not connected for this setting. Please connect Todoist and try again.",
        showWorkspace: false,
      };

    case PLATFORMS.NOTION:
      return {
        itemLabel: "Select Database",
        title: "Select Notion Database",
        workspaceLabel: "Select Database",
        showWorkspace: false,
      };

    case PLATFORMS.JIRA:
      return {
        workspaceLabel: "Select Workspace",
        projectLabel: "Select Project",
        itemLabel: "Select Board",
        title: "Select Jira Workspace, Project & Board",
        showWorkspace: true,
        isThreeStep: true,
      };

    default:
      return {
        itemLabel: "Select Project",
        title: "Select Default Settings",
        workspaceLabel: "Select Workspace",
        connectMessage: "Platform is not connected for this setting.",
        showWorkspace: true,
      };
  }
};

export const getWorkspaceId = (workspace, platform) => {
  if (platform === PLATFORMS.TRELLO) return workspace.id;
  if (platform === PLATFORMS.ASANA) return workspace.gid;
  if (platform === PLATFORMS.TODOIST) return workspace.id;
  if (platform === PLATFORMS.GITHUB) return workspace.id;
  if (platform === PLATFORMS.JIRA) return workspace.id;
  if (platform === PLATFORMS.LINEAR) return workspace.id;
  if (platform === PLATFORMS.CLICKUP) return workspace.id;
};

export const getWorkspaceName = (workspace, platform) => {
  if (platform === PLATFORMS.TRELLO)
    return workspace.displayName || workspace.name;
  if (platform === PLATFORMS.ASANA) return workspace.name;
  if (platform === PLATFORMS.TODOIST) return workspace.name;
  if (platform === PLATFORMS.GITHUB) return workspace.name;
  if (platform === PLATFORMS.JIRA) return workspace.name;
  if (platform === PLATFORMS.LINEAR) return workspace.name;
  if (platform === PLATFORMS.CLICKUP) return workspace.name;
};

export const getItemId = (item, platform) => {
  if (platform === PLATFORMS.TRELLO) return item.id;
  if (platform === PLATFORMS.ASANA) return item.gid;
  if (platform === PLATFORMS.TODOIST) return item.id;
  if (platform === PLATFORMS.GITHUB) return item.id;
  if (platform === PLATFORMS.JIRA) return item.id;
  if (platform === PLATFORMS.LINEAR) return item.id;
  if (platform === PLATFORMS.CLICKUP) return item.id;

};

export const createAuthState = (
  user,
  assistantId,
  isConfigRequired,
  isOnboarding,
) => {
  return btoa(
    JSON.stringify({
      userId: user.uuid,
      assistantId,
      isConfigRequired,
      timestamp: Date.now(),
      isOnboarding,
    }),
  );
};

export const platformMaps = {
  microsoft: new Map(),
  slack: new Map(),
  trello: new Map(),
};

export const PLATFORM_CONFIG = {
  microsoft: {
    fetchProfile: fetchOutlookProfile,
    authPath: "microsoft/auth",
    mapKey: "microsoft",
    settingKey: "setting",
  },
  slack: {
    fetchProfile: fetchSlackProfile,
    authPath: "slack/auth",
    mapKey: "slack",
    settingKey: "setting",
  },
  trello: {
    fetchProfile: fetchTrelloProfile,
    authPath: "trello/auth",
    mapKey: "trello",
    settingKey: "setting",
  },
};

const platformRequirements = {
  asana: ["id1", "id2"],
  trello: ["id2"],
  todoist: ["id2"],
  github: ["id2"],
  jira: ["id1", "id2"],
  linear: ["id2"],
  clickup: ["id2"],
};

export const checkIntegrationSetup = (platformName, setting) => {
  if (!platformName) return false;

  const platformKey = Object.keys(platformRequirements).find((key) =>
    platformName.toLowerCase().includes(key),
  );

  if (!platformKey) return false;

  return platformRequirements[platformKey].some(
    (idKey) => !setting?.integrationIds?.[idKey],
  );
};
